import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u041A\u044B\u0440\u0433\u044B\u0437\u0447\u0430",
  code: "ky",
  messages: {
    alert: {
      close: "\u0416\u0430\u0431\u0443\u0443"
    },
    authForm: {
      hidePassword: "\u0421\u044B\u0440\u0441\u04E9\u0437\u0434\u04AF \u0436\u0430\u0448\u044B\u0440\u0443\u0443",
      showPassword: "\u0421\u044B\u0440\u0441\u04E9\u0437\u0434\u04AF \u043A\u04E9\u0440\u0441\u04E9\u0442\u04AF\u04AF",
      submit: "\u0423\u043B\u0430\u043D\u0442\u0443\u0443"
    },
    banner: {
      close: "\u0416\u0430\u0431\u0443\u0443"
    },
    calendar: {
      nextMonth: "\u041A\u0438\u0439\u0438\u043D\u043A\u0438 \u0430\u0439",
      nextYear: "\u041A\u0438\u0439\u0438\u043D\u043A\u0438 \u0436\u044B\u043B",
      prevMonth: "\u0410\u043B\u0434\u044B\u04A3\u043A\u044B \u0430\u0439",
      prevYear: "\u0410\u043B\u0434\u044B\u04A3\u043A\u044B \u0436\u044B\u043B"
    },
    carousel: {
      dots: "\u041A\u04E9\u0440\u0441\u04E9\u0442\u04AF\u04AF \u04AF\u0447\u04AF\u043D \u0441\u043B\u0430\u0439\u0434\u0434\u044B \u0442\u0430\u043D\u0434\u0430\u04A3\u044B\u0437",
      goto: "{slide} \u0441\u043B\u0430\u0439\u0434\u0433\u0430 \u04E9\u0442\u04AF\u04AF",
      next: "\u041A\u0438\u0439\u0438\u043D\u043A\u0438",
      prev: "\u0410\u043B\u0434\u044B\u04A3\u043A\u044B"
    },
    chatPrompt: {
      placeholder: "\u0411\u0443\u043B \u0436\u0435\u0440\u0433\u0435 \u0431\u0438\u043B\u0434\u0438\u0440\u04AF\u04AF\u04A3\u04AF\u0437\u0434\u04AF \u0436\u0430\u0437\u044B\u04A3\u044B\u0437..."
    },
    chatPromptSubmit: {
      label: "\u0411\u0438\u043B\u0434\u0438\u0440\u04AF\u04AF \u0436\u04E9\u043D\u04E9\u0442\u04AF\u04AF"
    },
    colorMode: {
      dark: "\u041A\u0430\u0440\u0430\u04A3\u0433\u044B",
      light: "\u0416\u0430\u0440\u044B\u043A",
      switchToDark: "\u041A\u0430\u0440\u0430\u04A3\u0433\u044B \u0440\u0435\u0436\u0438\u043C\u0433\u0435 \u04E9\u0442\u04AF\u04AF",
      switchToLight: "\u0416\u0430\u0440\u044B\u043A \u0440\u0435\u0436\u0438\u043C\u0433\u0435 \u04E9\u0442\u04AF\u04AF",
      system: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430"
    },
    commandPalette: {
      back: "\u0410\u0440\u0442\u043A\u0430",
      close: "\u0416\u0430\u0431\u0443\u0443",
      noData: "\u041C\u0430\u0430\u043B\u044B\u043C\u0430\u0442 \u0436\u043E\u043A",
      noMatch: "\u042D\u0447 \u043D\u0435\u0440\u0441\u0435 \u0442\u0430\u0431\u044B\u043B\u0433\u0430\u043D \u0436\u043E\u043A",
      placeholder: "\u0411\u0443\u0439\u0440\u0443\u043A \u043A\u0438\u0440\u0433\u0438\u0437\u0438\u04A3\u0438\u0437 \u0436\u0435 \u0438\u0437\u0434\u04E9\u04E9\u2026"
    },
    contentSearch: {
      links: "\u0428\u0438\u043B\u0442\u0435\u043C\u0435\u043B\u0435\u0440",
      theme: "\u0422\u0435\u043C\u0430"
    },
    contentSearchButton: {
      label: "\u0418\u0437\u0434\u04E9\u04E9..."
    },
    contentToc: {
      title: "\u0411\u0443\u043B \u0431\u0435\u0442\u0442\u0435"
    },
    dashboardSearch: {
      theme: "\u0422\u0435\u043C\u0430"
    },
    dashboardSearchButton: {
      label: "\u0418\u0437\u0434\u04E9\u04E9..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u041A\u0430\u043F\u0442\u0430\u043B \u0442\u0438\u043B\u043A\u0435\u0441\u0438\u043D \u0436\u044B\u0439\u043D\u043E\u043E",
      expand: "\u041A\u0430\u043F\u0442\u0430\u043B \u0442\u0438\u043B\u043A\u0435\u0441\u0438\u043D \u043A\u0435\u04A3\u0435\u0439\u0442\u04AF\u04AF"
    },
    dashboardSidebarToggle: {
      close: "\u041A\u0430\u043F\u0442\u0430\u043B \u0442\u0438\u043B\u043A\u0435\u0441\u0438\u043D \u0436\u0430\u0431\u0443\u0443",
      open: "\u041A\u0430\u043F\u0442\u0430\u043B \u0442\u0438\u043B\u043A\u0435\u0441\u0438\u043D \u0430\u0447\u0443\u0443"
    },
    error: {
      clear: "\u0411\u0430\u0448\u043A\u044B \u0431\u0435\u0442\u043A\u0435 \u043A\u0430\u0439\u0442\u0443\u0443"
    },
    fileUpload: {
      removeFile: "{filename} \u04E9\u0447\u04AF\u0440\u04AF\u04AF"
    },
    header: {
      close: "\u041C\u0435\u043D\u044E\u043D\u0443 \u0436\u0430\u0431\u0443\u0443",
      open: "\u041C\u0435\u043D\u044E\u043D\u0443 \u0430\u0447\u0443\u0443"
    },
    inputMenu: {
      create: '"{label}" \u0436\u0430\u0441\u043E\u043E',
      noData: "\u041C\u0430\u0430\u043B\u044B\u043C\u0430\u0442 \u0436\u043E\u043A",
      noMatch: "\u042D\u0447 \u043D\u0435\u0440\u0441\u0435 \u0442\u0430\u0431\u044B\u043B\u0433\u0430\u043D \u0436\u043E\u043A"
    },
    inputNumber: {
      decrement: "\u0410\u0437\u0430\u0439\u0442\u0443\u0443",
      increment: "\u041A\u043E\u0448\u0443\u0443"
    },
    modal: {
      close: "\u0416\u0430\u0431\u0443\u0443"
    },
    pricingTable: {
      caption: "\u0411\u0430\u0430\u043B\u0430\u0440\u0434\u044B\u043D \u0441\u0430\u043B\u044B\u0448\u0442\u044B\u0440\u0443\u0443 \u0442\u0430\u0431\u043B\u0438\u0446\u0430\u0441\u044B"
    },
    prose: {
      codeCollapse: {
        closeText: "\u0416\u044B\u0439\u043D\u043E\u043E",
        name: "\u043A\u043E\u0434",
        openText: "\u041A\u0435\u04A3\u0435\u0439\u0442\u04AF\u04AF"
      },
      collapsible: {
        closeText: "\u0416\u0430\u0448\u044B\u0440\u0443\u0443",
        name: "\u043A\u0430\u0441\u0438\u0435\u0442\u0442\u0435\u0440",
        openText: "\u041A\u04E9\u0440\u0441\u04E9\u0442\u04AF\u04AF"
      },
      pre: {
        copy: "\u041A\u043E\u0434\u0434\u0443 \u0430\u043B\u043C\u0430\u0448\u0443\u0443 \u0431\u0443\u0444\u0435\u0440\u0438\u043D\u0435 \u043A\u04E9\u0447\u04AF\u0440\u04AF\u04AF"
      }
    },
    selectMenu: {
      create: '"{label}" \u0436\u0430\u0441\u043E\u043E',
      noData: "\u041C\u0430\u0430\u043B\u044B\u043C\u0430\u0442 \u0436\u043E\u043A",
      noMatch: "\u0421\u04AF\u0439\u043B\u04E9\u0448\u043A\u04E9\u043D \u043C\u0430\u0430\u043B\u044B\u043C\u0430\u0442\u0442\u0430\u0440 \u0436\u043E\u043A",
      search: "\u0418\u0437\u0434\u04E9\u04E9..."
    },
    slideover: {
      close: "\u0416\u0430\u0431\u0443\u0443"
    },
    table: {
      noData: "\u041C\u0430\u0430\u043B\u044B\u043C\u0430\u0442 \u0436\u043E\u043A"
    },
    toast: {
      close: "\u0416\u0430\u0431\u0443\u0443"
    }
  }
});
